import React from 'react';
import PropTypes from 'prop-types';
import { useSetRecoilState } from 'recoil';
import { ShowTimeLineState } from '../../appState';
import { useEffect } from 'react';

const ShowTimeLine = () => {
  const setShowTimeLine=useSetRecoilState(ShowTimeLineState)
  useEffect(()=>{
    setShowTimeLine(true)
    return()=>{
      setShowTimeLine(false)
    }
  },[])
  return null
};

ShowTimeLine.propTypes = {
  //
};

export default ShowTimeLine;
